import { render, staticRenderFns } from "./CashierAddDiverse.vue?vue&type=template&id=34ba5074&scoped=true"
import script from "./CashierAddDiverse.vue?vue&type=script&lang=ts"
export * from "./CashierAddDiverse.vue?vue&type=script&lang=ts"
import style0 from "./CashierAddDiverse.vue?vue&type=style&index=0&id=34ba5074&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ba5074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ba5074')) {
      api.createRecord('34ba5074', component.options)
    } else {
      api.reload('34ba5074', component.options)
    }
    module.hot.accept("./CashierAddDiverse.vue?vue&type=template&id=34ba5074&scoped=true", function () {
      api.rerender('34ba5074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cashier/CashierAddDiverse.vue"
export default component.exports